import { render } from "./InformatorNotification.vue?vue&type=template&id=1f789726&scoped=true"
import script from "./InformatorNotification.vue?vue&type=script&lang=js"
export * from "./InformatorNotification.vue?vue&type=script&lang=js"

import "./InformatorNotification.vue?vue&type=style&index=0&id=1f789726&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f789726"]])

export default __exports__